/**
 * Unescape common escape sequences in text for display
 */
export function unescapeText(text: string): string {
  if (!text) return text
  return text
    .replace(/\\'/g, "'")
    .replace(/\\"/g, '"')
    .replace(/\\\\/g, '\\')
}
